<!--
 * @Author: your name
 * @Date: 2021-04-14 11:14:14
 * @LastEditTime: 2021-04-23 11:21:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/order/index.vue
-->
<template>
  <div class="orderList">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 270px" v-model="formInline.accountName" clearable placeholder="账号名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input style="width: 270px" v-model="formInline.userName" clearable placeholder="商务对接人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">搜 索</el-button>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button type="primary" @click="addAccount">添加账号</el-button>
      </el-form-item>
    </el-form>
    <div style="padding:10px 0;font-size:15px;">
      订单名称：{{$route.query.name}}（{{$route.query.code}}），账号数：{{total}}
    </div>
    <div v-loading="loading">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column align="center" prop="date" label="账号名称">
          <template slot-scope="scope">
            <div class="accontBox">
              <div style="width:40px;height:40px;">
                <img v-if="scope.row.avatar" style="border-radius: 40px;width:100%;height:100%;" :src="scope.row.avatar" alt="">
                 <img v-else style="border-radius: 40px;width:100%;height:100%;" src="/img/media/weibo_default.png">
              </div>
              <div style="margin-left:10px;">
                <div class="info-wrap">
                  <el-tooltip :content="scope.row.mediaName?scope.row.mediaName:'--'" placement="bottom" effect="light">
                    <div class="nickname"><span>{{ scope.row.mediaName?scope.row.mediaName:'--' }}</span></div>
                  </el-tooltip>
                </div>
                {{ checkNull(scope.row.fansNum) ? '--' : scope.row.fansNum }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="mediaType" label="平台">
          <template slot-scope="scope">
            <div style="width:40px;height:40px;margin: 0 auto;">
                <!-- 平台logo -->
                <img v-if="scope.row.mediaType == 2" style="width:100%;height:100%;" src="@/assets/img/wb.png" alt="">
                <img v-if="scope.row.mediaType == 3" style="width:100%;height:100%;" src="@/assets/img/xhs.png" alt="">
                <img v-if="scope.row.mediaType == 5" style="width:100%;height:100%;" src="@/assets/img/bz.png" alt="">
                <img v-if="scope.row.mediaType == 6" style="width:100%;height:100%;" src="@/assets/img/ks.png" alt="">
                <div v-if="scope.row.mediaType == 1" class="typeImgWx"></div>
                <div v-if="scope.row.mediaType == 7" class="typeImgTb"></div>
                <div v-if="scope.row.mediaType == 4" class="typeImgDy"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="mediaBusinessInfoName" label="商务对接人">
          <template slot-scope="scope">
            {{scope.row.mediaBusinessInfoName?scope.row.mediaBusinessInfoName:'--'}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="publishType" label="发布形式">
          <template slot-scope="scope">
            {{scope.row.publishType?scope.row.publishType:'--'}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="putPrice" label="投放价格">
          <template slot-scope="scope">
            {{scope.row.putPrice?scope.row.putPrice:'--'}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="publishTime" label="投放时间">
          <template slot-scope="scope">
            {{scope.row.publishTime?scope.row.publishTime:'--'}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="orderAccountStatus" label="订单状态">
          <template slot-scope="scope">
            {{orderAccountStatus[scope.row.orderAccountStatus]}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <!--  0已完成  1待投放  2待商务接单  3已接单    4已拒单 -->
            <div v-if="scope.row.orderAccountStatus == 1">
              <el-button type="text" @click="putClick(scope.row,scope.row.id,1)">下投放</el-button>
              <el-button type="text" @click="deleteClick(scope.row.id,scope.row.orderAccountStatus,scope.row.orderId)">删除</el-button>
            </div>
            <div v-if="scope.row.orderAccountStatus == 2 || scope.row.orderAccountStatus == 3">
              <el-button type="text" @click="putClick(scope.row,scope.row.id,2)">修改投放需求</el-button>
              <el-button type="text" @click="deleteClick(scope.row.id,scope.row.orderAccountStatus,scope.row.orderId)">删除</el-button>
            </div>
            <div v-if="scope.row.orderAccountStatus == 4">
              <el-button type="text" @click="deleteClick(scope.row.id,scope.row.orderAccountStatus,scope.row.orderId)">删除</el-button>
            </div>
            <div v-if="scope.row.orderAccountStatus == 0">
              <el-button type="text" @click="detailsClick(scope.row.completeDetails)">查看完成备注</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align:right;padding-bottom:20px;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 下投放 -->
    <div v-if="dialogVisible">
      <el-dialog
        :title="putType==1?'下投放':'修改投放需求'"
        :visible.sync="dialogVisible"
        :show-close="false"
        center
        width="25%">
        <div>
          <div class="xinxi_box">
            <div class="xinxi_left_a">
              <div style="width:55px;height:55px;">
                <img v-if="putData.avatar" style="border-radius: 40px;width:100%;height:100%;" :src="putData.avatar" alt="">
                <img v-else style="border-radius: 40px;width:100%;height:100%;" src="/img/media/weibo_default.png">
              </div>
              <div style="margin-left:10px;">
                <div>{{putData.mediaName}}</div>
                <div>{{putData.fansNum}}</div>
              </div>
            </div>
            <div style="width:40px;height:40px;">
               <!-- 平台logo -->
                <img v-if="putData.mediaType == 2" style="width:100%;height:100%;" src="@/assets/img/wb.png" alt="">
                <img v-if="putData.mediaType == 3" style="width:100%;height:100%;" src="@/assets/img/xhs.png" alt="">
                <img v-if="putData.mediaType == 5" style="width:100%;height:100%;" src="@/assets/img/bz.png" alt="">
                <img v-if="putData.mediaType == 6" style="width:100%;height:100%;" src="@/assets/img/ks.png" alt="">
                <div v-if="putData.mediaType == 1" class="typeImgWx"></div>
                <div v-if="putData.mediaType == 7" class="typeImgTb"></div>
                <div v-if="putData.mediaType == 4" class="typeImgDy"></div>
            </div>
          </div>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="发布形式：" prop="publishType">
            <el-input v-model="ruleForm.publishType" placeholder="输入发布形式"></el-input>
          </el-form-item>
          <el-form-item label="投放价格：" prop="putPrice">
            <el-input type="number" v-model="ruleForm.putPrice" placeholder="输入投放价格"></el-input>
          </el-form-item>
          <el-form-item label="投放时间：" prop="publishTime">
            <el-date-picker
              style="width:100%;"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="ruleForm.publishTime"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="completeValueClick">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 添加账号 -->
    <div v-if="mediaListModal">
      <el-dialog title="添加账号" :visible.sync="mediaListModal" width="1000px" class="yhg-dialog">
        <div class="select-con">
          <span class="label">已选账号：</span>
          <div class="content">
            <el-tag class="select-tag" v-for="item in selectMediaList" :key="item.mediaType + '-' + item.mediaId" :closable="isMediaClosable(item)" :type="isMediaCloseType(item)" effect="dark"
              @close="onMediaTagClose(item,2)">
              <span class="select-tag-text">{{ item.name }}</span>
            </el-tag>
          </div>
        </div>
        <div class="filter-con">
          <span class="label">账号搜索：</span>
          <el-input size="small"  v-model="mediaPage.queryString" placeholder="账号名称/ID/链接" @keyup.enter.native="onMediaSearch"></el-input>
          <el-button class="search-btn" size="small" type="primary" @click="onMediaSearch">搜索</el-button>
        </div>
        <div class="table-con">
          <el-table :data="mediaTable" v-loading="mediaTableLoading" size="mini" @select="onSingleSelect" @select-all="onAllSelect" :row-key="getRowKeys" ref="mediaSelectTable">
            <el-table-column label="选择" type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
            <el-table-column label="账号名称" prop="name" align="center" min-width="80"></el-table-column>
            <el-table-column label="平台" prop="mediaType" align="center" min-width="60">
              <template slot-scope="scope">
                {{
                  mediaConfig.getAppointed("media_ch", scope.row.mediaType, "")
                }}
              </template>
            </el-table-column>
            <el-table-column label="粉丝数" prop="fansNum" align="center" min-width="140"></el-table-column>
            <el-table-column label="账号ID/链接" prop="url" min-width="160"></el-table-column>
          </el-table>
          <div class="pagination-wrap">
            <el-pagination background @size-change="mediaSizeChange" @current-change="mediaCurrentChange" :current-page.sync="mediaPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="mediaPage.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="mediaPage.total">
            </el-pagination>
          </div>
        </div>
        <div class="submit-con">
          <el-button type="primary" size="small" @click="onConfirmMediaChoose">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { order_account_list, update_order_account, add_order_account } from "@/api/order/index";
import { mediaConfig } from "@/const/config/media";
import { listAllMedia } from "@/api/business/contract";
export default {
  data() {
    return {
      loading:false,
      mediaConfig: mediaConfig,
      mediaListModal:false,
      mediaTableLoading: false,
      selectMediaList: [],
      disableMediaCheckbox:[],
      mediaTable: [],
      mediaPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      mediaForm: {
        queryString: "",
      },
      
      orderAccountStatus:['已完成','待商务接单','已接单','待投放','已拒单'],
      formInline: {
        accountName: "",
        userName:"",
        pageNum: 1,
        pageSize: 10,
        orderId:this.$route.query.id
      },
      putType:1,
      ruleForm:{
        publishType:"",
        putPrice:"",
        publishTime:""
      },
      rules: {
        publishType: [
          { required: true, message: '请输入发布形式', trigger: 'blur' },
        ],
        putPrice: [
          { required: true, message: '请输入投放价格', trigger: 'blur' },
        ],
        publishTime: [
          { required: true, message: '请选择投放时间', trigger: 'blur' },
        ],
      },
      detailsType:1,
      textarea:"",
      dialogVisible:false,
      total:0,
      ztList: [
        { value: 1, label: "待接单" },
        { value: 2, label: "已接单" },
        { value: 3, label: "已拒单" },
        { value: 4, label: "已完成" },
      ],
      tableData: [],
      putData:"",
    };
  },
  methods: {
    //添加账号
    addAccount(){
      this.mediaListModal = true;
      this.onMediaSearch();
    },
    //资源弹窗关闭
    onConfirmMediaChoose() {
      console.log('========数据=======',this.selectMediaList);
      this.$confirm('确认添加账号!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectMediaList.forEach(element => {
          element.createUserId = this.$store.state.user.user.id
          element.mediaName = element.name
        });
        add_order_account(this.selectMediaList,this.$route.query.id).then(res=>{
          if(res.code === 1){
            this.order_account_list()
          }
          console.log('======接口返回数据======',res)
        })
        this.mediaListModal = false;
      }).catch(() => {
               
      });
    },
    /**
     * 资源是否能被删除
     * @param item 标签元素
     */
    isMediaClosable(item) {
      if (
        this.operateType === "edit" &&
        this.disableMediaCheckbox.find(
          (v) => v.mediaType == item.mediaType && v.mediaId == item.mediaId
        )
      ) {
        return false; //禁用
      } else {
        return true;
      }
    },
    /**
     * 资源标签类型
     * @param item 标签元素
     */
    isMediaCloseType(item) {
      if (
        this.operateType === "edit" &&
        this.disableMediaCheckbox.find(
          (v) => v.mediaType == item.mediaType && v.mediaId == item.mediaId
        )
      ) {
        return "info"; //禁用
      } else {
        return "primary";
      }
    },
    /**
     * 资源标签删除
     * @param item 标签元素
     */
    onMediaTagClose(item) {
      let index = this.selectMediaList.findIndex(
        (v) => v.mediaId == item.mediaId && v.mediaType == item.mediaType
      );
      let tbItem = this.mediaTable.find(
        (v) => v.mediaId == item.mediaId && v.mediaType == item.mediaType
      );
      if (index !== -1) {
        this.selectMediaList.splice(index, 1);
        this.$refs.mediaSelectTable.toggleRowSelection(tbItem, false);
        this.$forceUpdate();
      }
    },
    //资源搜索
    onMediaSearch() {
      this.mediaPage.pageNum = 1;
      this.getMediaList();
    },
    /**
     * @param val 当前值
     * @param row 被选中/取消选中的对象
     */
    onSingleSelect(val, row) {
      let index = this.selectMediaList.findIndex(
        (v) => v.mediaId == row.mediaId && v.mediaType == row.mediaType
      );
      if (index === -1) {
        this.selectMediaList.push(row);
      } else {
        this.selectMediaList.splice(index, 1);
      }
    },
    /** 全选 */
    onAllSelect(val) {
      let other = [], //其他页数据
        current = []; //本页数据
      this.selectMediaList.forEach((v) => {
        if (
          this.mediaTable.findIndex(
            (v1) => v1.mediaType == v.mediaType && v1.mediaId == v.mediaId
          ) === -1
        ) {
          other.push(v);
        } else {
          current.push(v);
        }
      });
      let mediaPageValid = this.mediaTable.filter(
        (v) =>
          this.disableMediaCheckbox.findIndex(
            (v1) => v1.mediaType == v.mediaType && v1.mediaId == v.mediaId
          ) === -1
      );
      let mediaPageUnval = this.mediaTable.filter(
        (v) =>
          this.disableMediaCheckbox.findIndex(
            (v1) => v1.mediaType == v.mediaType && v1.mediaId == v.mediaId
          ) !== -1
      );
      let nonSelectArr = mediaPageValid.filter(
        (v) =>
          this.selectMediaList.findIndex(
            (v1) => v1.mediaType == v.mediaType && v1.mediaId == v.mediaId
          ) === -1
      );
      if (nonSelectArr.length > 0) {
        this.mediaTable.forEach((v) => {
          let index = this.selectMediaList.findIndex(
            (v2) => v2.mediaId == v.mediaId && v2.mediaType == v.mediaType
          );
          if (index === -1) {
            this.selectMediaList.push(v);
          }
        });
      } else {
        this.selectMediaList = [...other, ...mediaPageUnval];
      }
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    mediaSizeChange(val) {
      this.mediaPage.pageNum = 1;
      this.mediaPage.pageSize = val;
      this.getMediaList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    mediaCurrentChange(val) {
      this.mediaPage.pageNum = val;
      this.getMediaList();
    },
    /**
     * 获取表格行id
     * @param row
     */
    getRowKeys(row) {
      return row.mediaId + "_" + row.mediaType;
    },
    //获取资源列表
    getMediaList() {
      let obj = {
        pageSize: this.mediaPage.pageSize,
        pageNum: this.mediaPage.pageNum,
      };
      if (this.mediaForm.queryString && this.mediaForm.queryString.trim()) {
        obj.queryString = this.mediaForm.queryString.trim();
      }
      this.mediaTableLoading = true;
      listAllMedia(obj)
        .then((res) => {
          this.mediaTable = res.data || [];
          this.mediaPage.total = res.total;
          this.mediaTableLoading = false;

          this.$nextTick(() => {
            this.mediaTable.forEach((item) => {
              let selected =
                this.selectMediaList.findIndex(
                  (v) =>
                    v.mediaId == item.mediaId && v.mediaType == item.mediaType
                ) !== -1;
              this.$refs.mediaSelectTable.toggleRowSelection(item, selected);
            });
          });
        })
        .catch((err) => {
          this.mediaTable = [];
          this.mediaPage.total = 0;
          this.mediaTableLoading = false;
        });
    },
    //列表数据
    order_account_list(){
      this.loading = true;
      order_account_list(this.formInline).then(res=>{
        this.tableData = res.data;
        this.total = res.total;
        this.loading = false;
        console.log('====数据===',res)
      })
    },
    //提交
    completeValueClick(){
      this.ruleForm.orderId = this.putData.orderId;
      this.ruleForm.id = this.putData.id;
      console.log('=========下投放======',this.ruleForm)
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true;
          update_order_account(this.ruleForm,0).then(res=>{
            if(res.code === 1){
              this.$message({
                message: this.putType == 1?'下投放成功!':'修改投放需求成功!',
                type: 'success'
              });
              this.order_account_list()
              this.dialogVisible = false;
              this.ruleForm={
                publishType:"",
                putPrice:"",
                publishTime:""
              }
            }else{
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
    //完成信息
    putClick(data,id,type){
      this.putData = data;
      this.dialogVisible = true;
      this.putType = type
      if(type!=1){
        this.ruleForm={
          publishType:data.publishType,
          putPrice:data.putPrice,
          publishTime:data.publishTime,
        }
      }else{
        this.ruleForm={
          publishType:'',
          putPrice:'',
          publishTime:'',
        }
      }
    },
    //删除
    deleteClick(orderId,type,id){
      this.$confirm('确认删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        update_order_account({
          id:orderId,deleteFlag:1,orderId:id
        },1).then(res=>{
          if(res.code === 1){
            this.$message({
              message: '删除成功!',
              type: 'success'
            });
            this.order_account_list()
          }else{
            this.$message.error(res.msg);
          }
          console.log('========删除=======',res)
        })
      }).catch(() => {
        
      });
    },
    //完成
    detailsClick(text){
      this.$alert(text, '完成详情', {
          showConfirmButton:false,
          callback: action => {}
      });
    },
    //查询
    onSubmit() {
      this.formInline.pageNum = 1;
      this.order_account_list()
    },
    editClick(){},
    handleSizeChange(val) {
      this.formInline.pageSize = 1;
      this.order_account_list()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.order_account_list()
    }
  },
  computed: {},
  mounted() {
    this.order_account_list()
  },
};
</script>
<style lang="scss" scoped>
.orderList {
  margin-top: 10px;
  padding: 20px;
  background: #fff;
}
.xinxi_box{
  display: flex;
  height: 70px;
  margin: 0 auto;
  margin-bottom: 10px;
  margin-top: -20px;
  align-items: center;
  justify-content: space-between;
}
.xinxi_left_a{
  display: flex;
  align-items: center;
}
.accontBox{
  display: flex;
  align-items: center;
  margin-left:40px;
}
.typeImgWx{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
}
.typeImgTb{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -180px;
}
.typeImgDy{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -90px;
}
//基础信息
.info-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 12px;
  text-align: left;
  .nickname {
    max-width: 65px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
/deep/.select-con {
  .el-tag .el-icon-close {
    top: -8px;
  }
}
</style>